import stylesheet from './SuccessStoryOverlay.scss?inline';

import {NXTOverlay} from "../../parts/Overlay/Overlay";

class NXTSuccessStoryOverlay extends NXTOverlay {

    constructor() {
        super();
        this.customStyle += stylesheet;
    }

    get closeLabel(): string {
        return this.getAttribute('close-label') ?? 'Close';
    }

    renderHeader(): HTMLElement[] {
        return this.getSlotElements('overline');
    }

    renderFooter(): HTMLElement[] {
        const closeBtn = document.createElement('nxt-button');
        closeBtn.setAttribute('type', 'secondary');
        closeBtn.classList.add('close-button');
        closeBtn.innerText = this.closeLabel;
        closeBtn.addEventListener('click', (ev) => {
            ev.stopPropagation();
            this.close();
        });
        return [closeBtn];
    }

    renderMain(): HTMLElement[] {
        // Title + Underline
        const title = document.createElement('div');
        title.classList.add('story-head')
        this.cloneSlotContentIntoContainer(title, 'title', false, true, ['story-title']);
        this.cloneSlotContentIntoContainer(title, 'underline', false, true, ['story-underline']);
        // Claims
        const claims = document.createElement('div');
        claims.classList.add('story-claims');
        this.cloneSlotContentIntoContainer(claims, 'claim', false);
        // Content
        const contentArea = document.createElement('div');
        contentArea.classList.add('content');
        const descriptionArea = document.createElement('div');
        descriptionArea.classList.add('description');
        contentArea.appendChild(descriptionArea);
        this.cloneSlotContentIntoContainer(descriptionArea, '', true, true, ['story-content']);
        this.cloneSlotContentIntoContainer(contentArea, 'cta', false, true, ['story-cta']);
        const videoSlot = document.createElement('slot');
        videoSlot.name= 'video';
        contentArea.append(videoSlot);
        this.cloneSlotContentIntoContainer(contentArea, 'media', false, true, ['story-media']);
        // Combine
        return [title, claims, contentArea];
    }

}

customElements.define('nxt-success-story-overlay', NXTSuccessStoryOverlay);
